import { fromJS } from "immutable";
import { isResetType, isActionType } from "../util";
import {
  key,
  AI_CHANGED_INPUT_PATHS,
  AI_CHANGED_INPUT_PATHS_STORAGE_KEY,
  PERSIST_MODEL_DIFF_STATE,
  SELECTED_MODELS,
  STORED_MODEL_INPUTS,
  STORED_MODEL_INPUTS_STORAGE_KEY,
  UNSAVED_MODEL_INPUTS,
} from "./action";

const STORAGE_STATE_KEY = STORED_MODEL_INPUTS.split("/")[1];
const AI_CHANGED_STATE_KEY = AI_CHANGED_INPUT_PATHS.split("/")[1];

const readStoredModelInputs = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return undefined;
  }
  try {
    const raw = window.localStorage.getItem(STORED_MODEL_INPUTS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch (error) {
    return undefined;
  }
};

const readAiChangedInputPaths = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return undefined;
  }
  try {
    const raw = window.localStorage.getItem(AI_CHANGED_INPUT_PATHS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch (error) {
    return undefined;
  }
};

const persistStoredModelInputs = (value) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }
  try {
    if (value === undefined) {
      window.localStorage.removeItem(STORED_MODEL_INPUTS_STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORED_MODEL_INPUTS_STORAGE_KEY, JSON.stringify(value));
    }
  } catch (error) { }
};

const persistAiChangedInputPaths = (value) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }
  try {
    if (value === undefined) {
      window.localStorage.removeItem(AI_CHANGED_INPUT_PATHS_STORAGE_KEY);
    } else {
      window.localStorage.setItem(AI_CHANGED_INPUT_PATHS_STORAGE_KEY, JSON.stringify(value));
    }
  } catch (error) { }
};

const storedInputsFromStorage = readStoredModelInputs();
const aiChangedFromStorage = readAiChangedInputPaths();

const initialState = storedInputsFromStorage || aiChangedFromStorage
  ? {
    [key]: {
      ...(storedInputsFromStorage ? { [STORAGE_STATE_KEY]: storedInputsFromStorage } : {}),
      ...(aiChangedFromStorage ? { [AI_CHANGED_STATE_KEY]: aiChangedFromStorage } : {}),
    },
  }
  : {};

const reducer = (state = fromJS(initialState), action) => {
  const { type, payload } = action;
  if (isActionType(key, type)) {
    return state.setIn(type.split("/"), fromJS(payload));
  }
  if (isResetType(key, type)) {
    return fromJS(initialState);
  }
  switch (type) {
    // add non action type reducers here
    case SELECTED_MODELS:
      return state.setIn(type.split("/"), fromJS(payload));
    case STORED_MODEL_INPUTS: {
      return state.setIn(type.split("/"), fromJS(payload));
    }
    case AI_CHANGED_INPUT_PATHS: {
      return state.setIn(type.split("/"), fromJS(payload));
    }
    case PERSIST_MODEL_DIFF_STATE: {
      persistStoredModelInputs(payload?.storedModelInputs);
      persistAiChangedInputPaths(payload?.aiChangedInputPaths);
      return state;
    }
    case UNSAVED_MODEL_INPUTS: {
      return state.setIn(type.split("/"), fromJS(payload));
    }
    default:
      return state;
  }
};

export default reducer;
